export const MessageType = {
  // Inbound (embed library → shell)
  INIT: "INIT",
  START_UPLOAD: "START_UPLOAD",
  SUBMIT_SIGNUP: "SUBMIT_SIGNUP",
  LAUNCH_EDITOR: "LAUNCH_EDITOR",
  SUBMIT_CONTACT: "SUBMIT_CONTACT",
  SUBMIT_PARTNER_APPLICATION: "SUBMIT_PARTNER_APPLICATION",
  GET_SESSION: "GET_SESSION",
  LAUNCH_TOKEN_REQUEST: "LAUNCH_TOKEN_REQUEST",
  // Outbound (shell → embed library)
  READY: "READY",
  PROGRESS: "PROGRESS",
  UPLOAD_COMPLETE: "UPLOAD_COMPLETE",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  LAUNCH_READY: "LAUNCH_READY",
  CONTACT_SUCCESS: "CONTACT_SUCCESS",
  PARTNER_APPLICATION_SUCCESS: "PARTNER_APPLICATION_SUCCESS",
  SESSION_STATE: "SESSION_STATE",
  LAUNCH_TOKEN_SUCCESS: "LAUNCH_TOKEN_SUCCESS",
  ERROR: "ERROR",
} as const;

export const SOURCE_TAG = "nf-onboarding";
